import styled from 'styled-components';

export const Box = styled.div`
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 30px;
  padding-bottom: 22px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const HeaderRow = styled(Row)`
  justify-content: space-between;
  margin-bottom: 0px;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  margin-right: 12px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Subtitle = styled.h2`
  font-size: 18px;
  line-height: 20px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Link = styled.a`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['primary-60']};
  display: flex;
  align-items: center;
  margin-right: 12px;

  svg {
    color: ${(props) => props.theme.colors['primary-60']} !important;
    margin-right: 6px;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const EditButton = styled.button`
  background-color: ${(props) => props.theme.colors['neutral-30']};
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props) => props.theme.colors['neutral-40']};
  }

  svg {
    font-size: 12px;
  }
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const TooltipIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;

  svg {
    color: ${(props) => props.theme.colors['primary-60']};
    font-size: 16px;
  }
`;
